import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
/*
  Seek Slider
  
  Displays and changes the current time of the playing media.
*/
export default class SeekSlider extends Reflux.Component{
    constructor(props){
        super(props);
        this.state = {
            isDraggable: false
        }
        this.store = props.ControlsStore;
        this.ControlsActions = this.store.ControlsActions;
        this.video = this.store.video;
        this.timeDebounceTimeout = null;
    }

    componentDidMount() {
        this.bindEvents();
    }
    componentDidUpdate(prevProps, prevState){
        this.bindEvents();
    }

    bindEvents(){
        const eventNames = `mouseup.${this.video} touchend.${this.video} touchcancel.${this.video}`;
        $(document).off(eventNames).on(eventNames,(e)=>{
            this.state.isDraggable = false;
        })

    }
    shouldComponentUpdate(nextProps, nextState){
        return false;
    }

    doDrag(e){
        if(!this.state.isDraggable) return;
        let $this = $(ReactDOM.findDOMNode(this));
        let sliderLeft = $this.offset().left;
        let sliderWidth = $this.width();
        let cursorPageX = e.nativeEvent ? e.nativeEvent.pageX : e.pageX;
        let cursorSliderPos = cursorPageX-sliderLeft;
        let newSliderPos = cursorSliderPos/sliderWidth;
        let newTime = this.state.duration*newSliderPos;
        if(newTime<0){
            newTime=0;
        }
        else if(newTime>this.state.duration){
            newTime=this.state.duration;
        }
        this.ControlsActions.changeCurrentTime(newTime);
    }

    render() {
        const SeekSliderWrapperProps = {
            className: cx({
                'video-progress': true,
                'on-progress-drag': true
            }),
            onMouseMove: (e)=>{
                this.doDrag(e);
            },
            onTouchMove: (e) => {
                this.doDrag(e);
            },
            onMouseLeave: (e)=>{
                this.doDrag(e);
                this.timeDebounceTimeout = setTimeout( () => {
                    this.state.isDraggable = false;
                },300);
            },
            onMouseEnter: (e)=>{
                clearTimeout(this.timeDebounceTimeout);
            },
            onClick: (e)=>{
                e.preventDefault();
                this.state.isDraggable = true;
                this.doDrag(e);
                this.state.isDraggable = false;
            }
        }
        const SeekDragButtonProps = {
            ControlsStore: this.store,
            onDraggable: (flag) =>{
                this.state.isDraggable = flag;
            }
        }

        return (
            <div {...SeekSliderWrapperProps}>
                <div className="not-value">
                    <CurrentTimeBar video={this.props.video} ControlsStore={this.props.ControlsStore} />
                    <DragButton {...SeekDragButtonProps} />
                </div>
            </div>
        )
    }
}

SeekSlider.propTypes={
    ControlsStore: React.PropTypes.object.isRequired
}
SeekSlider.defaultProps={
}


class CurrentTimeBar extends Reflux.Component{
    constructor(props){
        super(props)
        this.state = {}
        this.store = props.ControlsStore;
        this.ControlsActions = this.store.ControlsActions;
    }

    componentDidMount() {
        //let $this = $(ReactDOM.findDOMNode(this));
    }
    shouldComponentUpdate(nextProps, nextState){
        return nextState.currentTime!=this.state.currentTime || nextState.duration!=this.state.duration;
    }

    render(){
        let width = (this.state.currentTime/this.state.duration)*100;
        const BarProps = {
            className: "seekslider",
            style: {
                width: width+'%'
            }
        }
        return (
            <div {...BarProps}></div>
        )
    }
}
CurrentTimeBar.propTypes={
    ControlsStore: React.PropTypes.object
}
CurrentTimeBar.defaultProps={
}

class DragButton extends Reflux.Component{
    constructor(props){
        super(props)
        this.state = {}
        this.store = props.ControlsStore;
        this.ControlsActions = this.store.ControlsActions;
    }

    componentDidMount() {
        //let $this = $(ReactDOM.findDOMNode(this));
    }
    shouldComponentUpdate(nextProps, nextState){
        return nextState.currentTime!=this.state.currentTime || nextState.duration!=this.state.duration;
    }

    render(){
        let leftPos = (this.state.currentTime/this.state.duration)*100;
        if(this.state.currentTime>=this.state.duration){
            leftPos = 100;
        }
        let style = {
            left: leftPos+'%'
        }
        if(leftPos>50){
            style={
                right: (100-leftPos)+'%'
            }
        }
        const DragProps = {
            className: 'progress-drag',
            style: style,
            onMouseDown: (e)=>{
                this.props.onDraggable(true);
            },
            onTouchStart: (e)=>{
                this.props.onDraggable(e);
            }
        }
        return(
            <div {...DragProps} ></div>
        )

    }
}
DragButton.propTypes={
    ControlsStore: React.PropTypes.object.isRequired,
    onDraggable: React.PropTypes.func.isRequired
}
DragButton.defaultProps={
}



// WEBPACK FOOTER //
// ./medscape_modules/video/player-controls/seek-slider.jsx